import { useMemo } from 'react';

import { useCanAccessCommunicationsDashboard } from '../../featureChecks';
import type { UseMainUIFeatureSettings } from '../../types';
import { uiFeatureAccessSymbol } from '../../types';

export const useCommsDashboardDigitalSafetyPageSettings: UseMainUIFeatureSettings<
  'communicationsDashboardDigitalSafetyPage'
> = (options) => {
  const canAccessDashboard = useCanAccessCommunicationsDashboard();

  return useMemo(() => {
    const overrides = options?.overrides?.communicationsDashboardDigitalSafetyPage ?? {};

    return {
      [uiFeatureAccessSymbol]: canAccessDashboard,
      ...overrides,
    };
  }, [options, canAccessDashboard]);
};
